interface TableLoadingProps {
  message?: string;
}

export const TableLoading = ({ message }: TableLoadingProps) => {
  return (
    <div className="flex flex-col items-center w-full text-center">
      <div className="mx-auto mb-4 w-8 h-8 rounded-full border-b-2 animate-spin border-primary"></div>
      <p className="text-muted-foreground">{message}</p>
    </div>
  );
};
